import * as types from './types';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import { uiActions } from 'state/modules/UI';
import * as subscriptionsActions from 'services/api/subscriptions';
import i18n from 'i18n-js';

// Get subscriptions
const fetchSubscriptionsRequest = () => ({
  type: types.FETCH_SUBSCRIPTIONS_REQUEST,
});

const fetchSubscriptionsSuccess = (payload) => ({
  type: types.FETCH_SUBSCRIPTIONS_SUCCESS,
  payload,
});

const fetchSubscriptionsFailed = () => ({
  type: types.FETCH_SUBSCRIPTIONS_FAILED,
});

export const fetchSubscriptions = (params = {}, options) => {
  return async (dispatch) => {
    dispatch(fetchSubscriptionsRequest());

    const response = await subscriptionsActions.fetchSubscriptions(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchSubscriptionsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchSubscriptionsFailed(error));
    }
  };
};

// Get Periods
const fetchSubscriptionsPeriodsRequest = () => ({
  type: types.FETCH_SUBSCRIPTIONS_PERIODS_REQUEST,
});

const fetchSubscriptionsPeriodsSuccess = (payload) => ({
  type: types.FETCH_SUBSCRIPTIONS_PERIODS_SUCCESS,
  payload,
});

const fetchSubscriptionsPeriodsFailed = () => ({
  type: types.FETCH_SUBSCRIPTIONS_PERIODS_FAILED,
});

export const fetchSubscriptionsPeriods = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchSubscriptionsPeriodsRequest());

    const response = await subscriptionsActions.fetchSubscriptionsPeriods(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchSubscriptionsPeriodsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchSubscriptionsPeriodsFailed(error));
  };
};

// Get subscription by id
const fetchSubscriptionByIdRequest = () => ({
  type: types.FETCH_SUBSCRIPTION_BY_ID_REQUEST,
});

const fetchSubscriptionByIdSuccess = (payload) => ({
  type: types.FETCH_SUBSCRIPTION_BY_ID_SUCCESS,
  payload,
});

const fetchSubscriptionByIdFailed = () => ({
  type: types.FETCH_SUBSCRIPTION_BY_ID_FAILED,
});

export const fetchSubscriptionById = (id) => {
  return async (dispatch) => {
    dispatch(fetchSubscriptionByIdRequest());

    const response = await subscriptionsActions.fetchSubscriptionById(id);

    if (response.ok) {
      return dispatch(fetchSubscriptionByIdSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchSubscriptionByIdFailed(error));
  };
};

// Update qualifications
const fetchUpdateSubscriptionQualificationsRequest = () => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_REQUEST,
});

const fetchUpdateSubscriptionQualificationsSuccess = (payload) => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_SUCCESS,
  payload,
});

const fetchUpdateSubscriptionQualificationsFailed = (errors) => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_QUALIFICATIONS_FAILED,
  errors,
});

export const fetchUpdateSubscriptionQualifications = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateSubscriptionQualificationsRequest());

    const response = await subscriptionsActions.fetchUpdateSubscriptionQualifications(id, payload);

    if (response.ok) {
      return dispatch(fetchUpdateSubscriptionQualificationsSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    return dispatch(fetchUpdateSubscriptionQualificationsFailed());
  };
};

// Change vehicle
const fetchChangeVehicleRequest = () => ({
  type: types.FETCH_CHANGE_VEHICLE_REQUEST,
});

const fetchChangeVehicleSuccess = (payload) => ({
  type: types.FETCH_CHANGE_VEHICLE_SUCCESS,
  payload,
});

const fetchChangeVehicleFailed = (errors) => ({
  type: types.FETCH_CHANGE_VEHICLE_FAILED,
  errors,
});

export const fetchChangeVehicle = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchChangeVehicleRequest());

    const response = await subscriptionsActions.fetchChangeVehicle(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('vehicle.vehicle_changed_successfully'),
        })
      );
      return dispatch(fetchChangeVehicleSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    return dispatch(fetchChangeVehicleFailed());
  };
};

// Change vehicle
const fetchCancelSubscriptionRequest = () => ({
  type: types.FETCH_CANCEL_SUBSCRIPTION_REQUEST,
});

const fetchCancelSubscriptionSuccess = (payload) => ({
  type: types.FETCH_CANCEL_SUBSCRIPTION_SUCCESS,
  payload,
});

const fetchCancelSubscriptionFailed = (errors) => ({
  type: types.FETCH_CANCEL_SUBSCRIPTION_FAILED,
  errors,
});

export const fetchCancelSubscription = (id) => {
  return async (dispatch) => {
    dispatch(fetchCancelSubscriptionRequest());

    const response = await subscriptionsActions.fetchCancelSubscription(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('common.updated_successfully'),
        })
      );
      return dispatch(fetchCancelSubscriptionSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    return dispatch(fetchCancelSubscriptionFailed());
  };
};

// Update subscription
const fetchUpdateSubscriptionRequest = () => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_REQUEST,
});

const fetchUpdateSubscriptionSuccess = (payload) => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_SUCCESS,
  payload,
});

const fetchUpdateSubscriptionFailed = (errors) => ({
  type: types.FETCH_UPDATE_SUBSCRIPTION_FAILED,
  errors,
});

export const fetchUpdateSubscription = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateSubscriptionRequest());

    const response = await subscriptionsActions.fetchUpdateSubscription(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('common.updated_successfully'),
        })
      );
      return dispatch(fetchUpdateSubscriptionSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );
    return dispatch(fetchUpdateSubscriptionFailed());
  };
};

// Update exchange type
const fetchUpdateExchangeRequest = () => ({
  type: types.FETCH_UPDATE_EXCHANGE_REQUEST,
});

const fetchUpdateExchangeSuccess = (payload) => ({
  type: types.FETCH_UPDATE_EXCHANGE_SUCCESS,
  payload,
});

const fetchUpdateExchangeFailed = (errors) => ({
  type: types.FETCH_UPDATE_EXCHANGE_FAILED,
  errors,
});

export const fetchUpdateExchange = (id, payload) => {
  return async (dispatch) => {
    dispatch(fetchUpdateExchangeRequest());

    const response = await subscriptionsActions.fetchUpdateExchange(id, payload);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('common.updated_successfully'),
        })
      );
      return dispatch(fetchUpdateExchangeSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data);

    if (typeof formattedError === 'string') {
      dispatch(fetchUpdateExchangeFailed());

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError[0]?.message || formattedError[0],
      })
    );

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    return dispatch(fetchUpdateExchangeFailed({ errors }));
  };
};

/* 
  RESET CHANGE VEHICLE
*/
const resetChangeVehicleSuccess = (payload) => ({
  type: types.RESET_CHANGE_VEHICLE_SUCCESS,
  payload,
});

export const resetChangeVehicle = () => {
  return async (dispatch) => {
    dispatch(resetChangeVehicleSuccess());
  };
};

/* 
  RESET SUBSCRIPTION
*/
const resetSubscriptionSuccess = (payload) => ({
  type: types.RESET_SUBSCRIPTION_SUCCESS,
  payload,
});

export const resetSubscription = () => {
  return async (dispatch) => {
    dispatch(resetSubscriptionSuccess());
  };
};

/* 
  RESET SUBSCRIPTION
*/
const resetUpdateSubscriptionSuccess = (payload) => ({
  type: types.RESET_UPDATE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const resetUpdateSubscription = () => {
  return async (dispatch) => {
    dispatch(resetUpdateSubscriptionSuccess());
  };
};

/* 
  RESET CANCEL SUBSCRIPTION
*/
const resetCancelSubscriptionSuccess = (payload) => ({
  type: types.RESET_CANCEL_SUBSCRIPTION_SUCCESS,
  payload,
});

export const resteCancelSubscription = () => {
  return async (dispatch) => {
    dispatch(resetCancelSubscriptionSuccess());
  };
};

/* 
  RESET EXCHANGE
*/
const resetExchangeSubscriptionSuccess = (payload) => ({
  type: types.RESET_EXCHANGE_SUBSCRIPTION_SUCCESS,
  payload,
});

export const resetExchangeSubscription = () => {
  return async (dispatch) => {
    dispatch(resetExchangeSubscriptionSuccess());
  };
};

// Get subscriptions
const fetchSubscriptionPricingRequest = () => ({
  type: types.FETCH_SUBSCRIPTION_PRICING_REQUEST,
});

const fetchSubscriptionPricingSuccess = (payload) => ({
  type: types.FETCH_SUBSCRIPTION_PRICING_SUCCESS,
  payload,
});

const fetchSubscriptionPricingFailed = () => ({
  type: types.FETCH_SUBSCRIPTION_PRICING_FAILED,
});

export const fetchSubscriptionPricing = (id, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchSubscriptionPricingRequest());

    const response = await subscriptionsActions.fetchSubscriptionPricing(id, params);

    if (response.ok) {
      return dispatch(fetchSubscriptionPricingSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchSubscriptionPricingFailed(error));
  };
};

// Get noc aggregates
const fetchAggregatesRequest = () => ({
  type: types.FETCH_VEHICLE_GROUPS_AGGREGATES_REQUEST,
});

const fetchAggregatesSuccess = (payload) => ({
  type: types.FETCH_VEHICLE_GROUPS_AGGREGATES_SUCCESS,
  payload,
});

const fetchAggregatesFailed = (error) => ({
  type: types.FETCH_VEHICLE_GROUPS_AGGREGATES_FAILED,
  error,
});

export const fetchAggregates = (params) => {
  return async (dispatch) => {
    dispatch(fetchAggregatesRequest());

    const response = await subscriptionsActions.fetchAggregates(params);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchAggregatesSuccess({
          data: response.data,
          pagination,
        })
      );
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchAggregatesFailed(error));
  };
};

// Get noc aggregates total
const fetchAggregatesTotalsRequest = () => ({
  type: types.FETCH_AGGREGATES_TOTALS_REQUEST,
});

const fetchAggregatesTotalsSuccess = (payload) => ({
  type: types.FETCH_AGGREGATES_TOTALS_SUCCESS,
  payload,
});

const fetchAggregatesTotalsFailed = (error) => ({
  type: types.FETCH_AGGREGATES_TOTALS_FAILED,
  error,
});

export const fetchAggregatesTotals = (params) => {
  return async (dispatch) => {
    dispatch(fetchAggregatesTotalsRequest());

    const response = await subscriptionsActions.fetchAggregatesTotals(params);

    if (response.ok) {
      return dispatch(fetchAggregatesTotalsSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchAggregatesTotalsFailed(error));
  };
};
